(function () {
  "use strict";
  function sanitizeCep(cep) { return (cep || "").replace(/\D/g, ""); }
  function maskCep(value) {
    const digits = sanitizeCep(value).slice(0, 8);
    return digits.length > 5 ? digits.slice(0, 5) + "-" + digits.slice(5) : digits;
  }
  function formatMoney(value) {
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
  }
  function fixoParaCep(cep, subtotal) {
    const n = parseInt(cep.slice(0, 5), 10);
    if (isNaN(n)) return null;
    let zona;
    if (n >= 1000 && n <= 39999) zona = { price: 9.9, prazo: "4 a 8 dias úteis", sudeste: true };
    else if (n >= 40000 && n <= 65999) zona = { price: 19.9, prazo: "6 a 15 dias úteis" };
    else if (n >= 66000 && n <= 69999) zona = { price: 29.9, prazo: "11 a 21 dias úteis" };
    else if (n >= 70000 && n <= 76799) zona = { price: 19.9, prazo: "6 a 12 dias úteis" };
    else if (n >= 76800 && n <= 77999) zona = { price: 29.9, prazo: "11 a 21 dias úteis" };
    else if (n >= 78000 && n <= 78899) zona = { price: 19.9, prazo: "6 a 12 dias úteis" };
    else if (n >= 78900 && n <= 78999) zona = { price: 29.9, prazo: "11 a 21 dias úteis" };
    else if (n >= 79000 && n <= 79999) zona = { price: 19.9, prazo: "6 a 12 dias úteis" };
    else if (n >= 80000 && n <= 99999) zona = { price: 19.9, prazo: "5 a 9 dias úteis" };
    else return null;
    return zona.sudeste && subtotal >= 249.9
      ? { label: "Frete grátis", prazo: zona.prazo, price: 0 }
      : { label: "Frete fixo", prazo: zona.prazo, price: zona.price };
  }
  async function getCartSubtotal() {
    try { return ((await (await fetch("/cart.js")).json()).total_price || 0) / 100; }
    catch (e) { return 0; }
  }
  function renderResult(container, fixo) {
    container.innerHTML = "";
    if (!fixo) {
      container.innerHTML = '<div class="frenet-shipping__error">Não foi possível identificar o frete para este CEP.</div>';
      return;
    }
    const isFree = fixo.price === 0;
    const el = document.createElement("div");
    el.className = "frenet-shipping__result-item";
    el.innerHTML =
      '<span class="frenet-shipping__carrier">' + fixo.label + '</span>' +
      (fixo.prazo ? '<span class="frenet-shipping__deadline">' + fixo.prazo + '</span>' : "") +
      '<span class="frenet-shipping__price' + (isFree ? " frenet-shipping__price--free" : "") + '">' +
      (isFree ? "Grátis" : formatMoney(fixo.price)) + '</span>';
    container.appendChild(el);
  }
  async function calcular(widget) {
    const input = widget.querySelector(".frenet-shipping__input");
    const resultsEl = widget.querySelector(".frenet-shipping__results");
    if (!input || !resultsEl) return;
    const cep = sanitizeCep(input.value);
    if (cep.length === 8) localStorage.setItem("frenet_cep", cep);
    if (cep.length !== 8) {
      resultsEl.innerHTML = '<div class="frenet-shipping__error">Digite um CEP válido com 8 dígitos.</div>';
      return;
    }
    const subtotal = widget.dataset.context === "cart"
      ? await getCartSubtotal()
      : parseFloat(widget.dataset.productPrice) || 0;
    renderResult(resultsEl, fixoParaCep(cep, subtotal));
  }
  document.addEventListener("input", function (e) {
    const input = e.target.closest && e.target.closest(".frenet-shipping__input");
    if (input) input.value = maskCep(input.value);
  });
  document.addEventListener("keydown", function (e) {
    const input = e.target.closest && e.target.closest(".frenet-shipping__input");
    if (input && e.key === "Enter") {
      e.preventDefault();
      const widget = input.closest(".frenet-shipping");
      if (widget) calcular(widget);
    }
  });
  document.addEventListener("click", function (e) {
    const button = e.target.closest && e.target.closest(".frenet-shipping__button");
    if (!button) return;
    e.preventDefault();
    const widget = button.closest(".frenet-shipping");
    if (widget) calcular(widget);
  });
  function restore(widget) {
    if (!widget || widget.dataset.frenetReady === "1") return;
    widget.dataset.frenetReady = "1";
    const input = widget.querySelector(".frenet-shipping__input");
    if (!input) return;
    const savedCep = localStorage.getItem("frenet_cep");
    if (savedCep) {
      input.value = maskCep(savedCep);
      calcular(widget);
    }
  }
  function scan(root) {
    (root || document).querySelectorAll(".frenet-shipping").forEach(restore);
  }
  function boot() {
    scan(document);
    const observer = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(".frenet-shipping")) restore(node);
          if (node.querySelectorAll) node.querySelectorAll(".frenet-shipping").forEach(restore);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot)
    : boot();
})();